
import { defineComponent } from "vue";

export default defineComponent({
  name: "botao-cadastrar",
  props: {
    to: {
      type: [Object, String],
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: "Novo Cadastro",
    },
  },
});
